import { createBrowserHistory } from 'history';
import React from 'react';
import { Route, Router } from 'react-router-dom';
import MMToast from './components/modal/toast';
import './components/styles/index.less';
import Index from './pages/index';

const App: React.FC = () => {
  return (
    <Router history={createBrowserHistory()} >
      <MMToast></MMToast>
      <Route path="/" component={Index[0].Page}></Route>
    </Router>
  );
}

export default App;
